import styled from "styled-components";

export const TwoTextContainer = styled.div`
  width: 100%;        
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  letter-spacing: 0.1em;
`;

export const TwoTextTitle = styled.p`
  letter-spacing: 0.1em;
  line-height: 7px;
  color: #8E8E93;
  font-size: 11px;
  margin: 0;
`;

export const TwoTextTitleWithEdit = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EditIconWrapper = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
`;
export const TwoTextContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  letter-spacing: -0.3px;
  color: #1C1C1E;
  font-size: 13px;
  font-weight: 500;
`;

export const TwoTextLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
  white-space: pre-line;
`;
